import { render, staticRenderFns } from "./Clear.vue?vue&type=template&id=10e5fe39&scoped=true&"
import script from "./Clear.vue?vue&type=script&lang=ts&"
export * from "./Clear.vue?vue&type=script&lang=ts&"
import style0 from "./Clear.vue?vue&type=style&index=0&id=10e5fe39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5fe39",
  null
  
)

export default component.exports